import React from 'react';
import { Link } from 'react-router';

import whiteImg from 'assets/images/logo-moka-white.svg';
import mokaImg from 'assets/images/logo-moka.png';

import styles from './NavMokaLogo.css';

interface NavMokaLogoProps {
  readonly link: string;
  readonly isMokaOpenApiRedirect: boolean;
}

export default function NavMokaLogo({
  isMokaOpenApiRedirect,
  link,
}: NavMokaLogoProps) {
  let logo = '';

  if (isMokaOpenApiRedirect) {
    logo = whiteImg;
  } else {
    logo = mokaImg;
  }

  return (
    <div className={`${styles.wrapper}`}>
      <Link to={link} className="navbar-brand mk-brand">
        <img src={logo} className="logo-moka" />
      </Link>
    </div>
  );
}
